import { Router } from "aurelia-router";
import { RulesTab } from "./tabs/rules/rules";
import { observable } from "aurelia-binding";
import { RuleCollections } from "./tabs/rule-collections/rule-collections";
import { autoinject } from "aurelia-dependency-injection";
import { Claims } from "../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { type TabModel } from "@rightship-tech/common-ui/models/basic.models";

@autoinject()
export class Rules {

    public steps: TabModel[];

    @observable
    currentTab: TabModel;

    constructor(protected router: Router,
        private userClaimsService: UserClaimsService,
        private ruleCollecions: RuleCollections,
        private RulesTab: RulesTab) {

            this.steps = this.getSteps();
        }
    
    public currentStepKey: string = "tabs-rules";
    
    getSteps(): TabModel[] {
        return [
            // RuleCollections
            {
                step: 0,
                title: "Rule Collections",
                show: this.userClaimsService.hasPermission(Claims.CanAccessRules),
                vm : this.ruleCollecions
            },
            //Rules Config
            {
                step: 1,
                title: "Rules",
                show: [Claims.CanAccessRules, Claims.CanEditRules].filter(x => this.userClaimsService.hasPermission(x)).length > 0,
                vm: this.RulesTab
            }
        ];
    }
    
    public onStepClicked = (step: TabModel) => {
        if (!step) {
            return;
        }

        if (step.param) {
            const params = this.router.currentInstruction.params;
            params.step = step.param;

            const state = window.history.state;

            this.router.navigateToRoute(this.router.currentInstruction.config.name, params, {
                trigger: false,
                replace: true,
            });

            window.history.replaceState(state, "Company");
        }
    }
}